import { getSessionUUID } from '../components/lib/AuthToken';


const request = async (url, options = {}) => {
    const sessionToken = await getSessionUUID();
    const response = await fetch(url, {
        ...options,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionToken}`,
            ...(options.headers || {}),
        },
    });
    const data = await response.json();
    if (!response.ok) {
        throw new Error(data.error || 'Warehouse map request failed');
    }
    return data;
};

export const fetchWarehouseMaps = () => request('/warehouse-map/maps');

export const createWarehouseMap = (map) => request('/warehouse-map/maps', {
    method: 'POST',
    body: JSON.stringify(map),
});

export const fetchWarehouseMap = (mapId, search = '') => {
    const query = search.trim() ? `?search=${encodeURIComponent(search.trim())}` : '';
    return request(`/warehouse-map/maps/${mapId}${query}`);
};

export const saveWarehouseMapLayout = (mapId, layout) => request(
    `/warehouse-map/maps/${mapId}/layout`,
    {
        method: 'PUT',
        body: JSON.stringify(layout),
    },
);

export const fetchWarehouseRackView = (mapId, zoneId, search = '') => {
    const query = search.trim() ? `?search=${encodeURIComponent(search.trim())}` : '';
    return request(`/warehouse-map/maps/${mapId}/zones/${zoneId}/rack${query}`);
};

export const fetchWarehouseMapPallet = (palletId) => request(
    `/warehouse-map/pallets/${palletId}`,
);
